export const supplierProductActions = {

};